<p-tabs [(value)]="activeTab" (valueChange)="handleTabChange($event)">
    <p-tablist>
        <p-tab [value]="0">Simulation Data</p-tab>
        <p-tab [value]="1">Activity Sequence</p-tab>
        <p-tab [value]="2">Output</p-tab>
    </p-tablist>
    <p-tabpanels>
    <p-tabpanel [value]="0">
        <div class="grid field col-12">
            <p-accordion [multiple]="false" class="grid field col-12" value="0">
                <p-accordion-panel [value]="0">
                    <p-accordion-header>Header</p-accordion-header>
                    <p-accordion-content>
                        <simulation-header (onNewVersion)="cloneSimulation()"></simulation-header>
                    </p-accordion-content>
                </p-accordion-panel>
                <p-accordion-panel [value]="1">
                    <p-accordion-header>Goals</p-accordion-header>
                    <p-accordion-content>
                        <simulation-goals></simulation-goals>
                    </p-accordion-content>
                </p-accordion-panel>
                <p-accordion-panel [value]="2">
                    <p-accordion-header>Site Details</p-accordion-header>
                    <p-accordion-content>
                        <simulation-site-detail></simulation-site-detail>
                    </p-accordion-content>
                </p-accordion-panel>
                <p-accordion-panel [value]="3">
                    <p-accordion-header>Expenses</p-accordion-header>
                    <p-accordion-content>
                        <simulation-expenses></simulation-expenses>
                    </p-accordion-content>
                </p-accordion-panel>
                <p-accordion-panel [value]="4">
                    <p-accordion-header>Well Information</p-accordion-header>
                    <p-accordion-content>
                        <simulation-well-information></simulation-well-information>
                    </p-accordion-content>
                </p-accordion-panel>
                <p-accordion-panel [value]="5">
                    <p-accordion-header>Fluid Information</p-accordion-header>
                    <p-accordion-content>
                        <simulation-chemistry></simulation-chemistry>
                    </p-accordion-content>
                </p-accordion-panel>
                <p-accordion-panel [value]="6">
                    <p-accordion-header>Defaults</p-accordion-header>
                    <p-accordion-content>
                        <simulation-activity-defaults></simulation-activity-defaults>
                    </p-accordion-content>
                </p-accordion-panel>
            </p-accordion>
        </div>
    </p-tabpanel>
    <p-tabpanel [value]="1">
        <simulation-sequence (sequenceChanged)="runCalculatedFields()" [wellInfo]="wellCom.wellInfo"></simulation-sequence>
        <div class="grid field col-12">
            <p-button 
                class="col-6 md:col-4 ui-lg-2"
                (click)="runCalculatedFields()"
                label="Calculate Changes"
                pTooltip="Apply user input changes and recalculate all data">
            </p-button>
            <p-button 
                class="col-6 md:col-4 ui-lg-2"
                (click)="generateActivitiesFromPlugs()"
                label="Apply Simulation Data"
                pTooltip="Apply data from well information's plug definitions to create simulation activities">
            </p-button>
        </div>
    </p-tabpanel>
    <p-tabpanel [value]="2">
        <div class="grid field col-12">
            <p-accordion [multiple]="true" class="grid field col-12" [value]="[0, 1]">
                <p-accordion-panel [value]="0">
                    <p-accordion-header>Cost Estimates</p-accordion-header>
                    <p-accordion-content>
                    <div class="grid field col-12">
                        <!-- Chemical Cost -->
                        <div class="col-12 md:col-1">
                            <label>Chemical Cost</label>
                        </div>
                        <div class="col-12 md:col-3">
                            <label class="readOnly-label">$ {{totalChemicalCost | number}}</label>
                        </div>
                        <!-- Service Cost -->
                        <div class="col-12 md:col-1">
                            <label>Service Cost</label>
                        </div>
                        <div class="col-12 md:col-3">
                            <label class="readOnly-label">$ {{totalServiceCost | number}}</label>
                        </div>
                        <!-- Total Cost -->
                        <div class="col-12 md:col-1">
                            <label>Total Cost</label>
                        </div>
                        <div class="col-12 md:col-3">
                            <label class="readOnly-label">$ {{totalChemicalCost + totalServiceCost | number}}</label>
                        </div>
                    </div>
                    </p-accordion-content>
                </p-accordion-panel>
                <p-accordion-panel [value]="1">
                    <p-accordion-header>Performance Summary</p-accordion-header>
                    <p-accordion-content>
                        <simulation-performance></simulation-performance>
                    </p-accordion-content>
                </p-accordion-panel>
            </p-accordion>
        </div>
        <div class="grid field col-12">
            <div class="col-12 md:col-6">
                <!-- <ng-dygraphs
                    [data]="depthVsReData"
                    [options]="depthVsReOptions">
                </ng-dygraphs> -->
            </div>
            <div class="col-12 md:col-6">
                <!-- <ng-dygraphs
                    [data]="avData"
                    [options]="avOptions">
                </ng-dygraphs> -->
            </div>
            <div class="col-12 md:col-6">
                <!-- <ng-dygraphs
                    [data]="pumpedBblsData"
                    [options]="pumpedBblsOptions">
                </ng-dygraphs> -->
            </div>
            <div class="col-12 md:col-6">
                <!-- <ng-dygraphs
                    [data]="flowbackBblsData"
                    [options]="flowbackBblsOptions">
                </ng-dygraphs> -->
            </div>
        </div>
    </p-tabpanel>
    </p-tabpanels>
</p-tabs>
<div class="grid field col-12">
    <div class="col-6 md:col-4 ui-lg-2">
        <button pButton (click)="saveSimulation()" class="wideish">
            <span pButtonLabel>Save</span>
        </button>
    </div>
    <div class="col-6 md:col-4 ui-lg-2">
        <button pButton (click)="exportSimulation()" class="wideish">
            <span pButtonLabel>Export</span>
        </button>
    </div>
    <div class="col-6 md:col-4 ui-lg-2">
        <button pButton (click)="navigateToSimulationList()" class="p-button-secondary wideish">
            <span pButtonLabel>Cancel</span>
        </button>
    </div>
</div>
<div class="grid field col-12">
    <span>.</span>
</div>